import { ClassCreationList } from "./ClassCreationList";
import { ClassCreationEdit } from "./ClassCreationEdit";

export default {
  list: ClassCreationList,
  edit: ClassCreationEdit,
};

